module.exports = __webpack_public_path__ + "img/icon1.201bff7a.png";